import React from 'react';
import { Modal, Row, Col, Progress } from 'antd';
import PlayerTimeline from '../player/PlayerTimeline';
import PlaylistRenderer from '../player/renderers/PlaylistRenderer';
import CodexPlayerHelper from '../player/CodexPlayerHelper';

class PlaylistPreviewPopup extends React.Component {
    state = {
        previewPlaylistVisible: false,
        previewPlaylistData: null
    };

    constructor(props) {
        super(props);

        this.previewTimelineRef = React.createRef();
    }

    showPreviewPlaylist = (data = null, doShow = true) => {
        // console.log("data " + JSON.stringify(data))
        return new Promise((resolve, reject) => {
            this.setState({ previewPlaylistData: data, previewPlaylistVisible: doShow }, () => { resolve() });
        })
    }

    stopPreviewPlaylist = () => {
        if (this.previewTimelineRef.current)
            this.previewTimelineRef.current.stopTimer();
        this.showPreviewPlaylist(null, false);
    }

    //callthis function to preview playlist
    previewPlaylist = (playlistData, mediaDatas) => {
        const data = CodexPlayerHelper.generatePlaylistReadable(playlistData, mediaDatas);

        this.showPreviewPlaylist(data, true).then(() => {
            if (this.previewTimelineRef.current) {
                this.previewTimelineRef.current.resetTimer();
                this.previewTimelineRef.current.startTimer(data);
            }
        })
    }

    render() {
        return (
            <Modal
                title=""
                centered
                open={this.state.previewPlaylistVisible}
                footer={null}
                onOk={() => this.stopPreviewPlaylist()}
                onCancel={() => this.stopPreviewPlaylist()}
                wrapClassName="modal-window"
                width={800}
            >
                <Row justify="space-around" align="middle" >
                    <Col style={{ width: "700px", height: "500px" }}>
                        <PlayerTimeline ref={this.previewTimelineRef}>
                            {
                                (time) => {
                                    const percent = Math.floor(100 * (time - Math.floor(time / this.state.previewPlaylistData.total_time) * this.state.previewPlaylistData.total_time) / this.state.previewPlaylistData.total_time);

                                    return <div style={{ width: "700px", height: "500px", border: "8px solid black", position: "relative" }}>
                                        <PlaylistRenderer time={time} data={this.state.previewPlaylistData}></PlaylistRenderer>
                                        <Progress strokeColor="red" strokeWidth={3} showInfo={false} style={{ position: "absolute", bottom: 0, height: "12px" }} percent={
                                            percent
                                        }></Progress>
                                    </div>
                                }
                            }
                        </PlayerTimeline>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default PlaylistPreviewPopup